<template>
    <v-container>
        <v-layout>
            <v-flex xs4 md3>
                <v-layout mb-3>
                    <v-flex>
                        <v-menu content-class="menu-card mt-2 app-content flex"
                                min-width="450px"
                                transition="scale-transition"
                                :close-on-content-click="false"
                                offset-y
                                full-width
                                v-model="popupFiltro">
                            <v-btn slot="activator" class="btn-default" color="dark" large outline>
                                <v-icon color="primary">lnr-funnel</v-icon>
                                <div class="pl-1">Filtrar</div>
                            </v-btn>
                            <v-layout column class="card">
                                <v-flex mb-4>
                                    <v-label>Perfis</v-label>
                                    <v-text-field mb-4 ref="textField" v-model="filtro.nome_perfil" flat solo
                                                  hide-details
                                                  maxlength="100"
                                                  @keyup.enter="filtrar"></v-text-field>
                                </v-flex>
                                <v-flex>

                                    <v-label>Usuários</v-label>
                                    <v-text-field ref="textField" v-model="filtro.usuarios" flat solo hide-details
                                                  maxlength="100"
                                                  @keyup.enter="filtrar"></v-text-field>
                                </v-flex>
                                <v-layout mt-3 justify-center>
                                    <v-flex xs4>
                                        <v-btn class="btn-default" color="dark" outline @click="limpar">Limpar</v-btn>
                                    </v-flex>
                                    <v-flex xs4>
                                        <v-btn class="btn-default primary" @click="filtrar">Filtrar</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-layout>
                        </v-menu>
                    </v-flex>
                    <v-flex>
                        <v-btn class="btn-default" color="primary" large :to="{name:'cadastro_perfil'}">
                            Cadastrar
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-layout column class="card table">
            <data-table ref="table" url="/admin/perfis" :filter="dtFiltro"
                        :headers="headers">
                <template slot="items" slot-scope="{ item }">
                    <td>{{ item.nome_perfil }}</td>
                    <td class="text-truncate">{{ item.usuarios | agg }}</td>
                    <td width="1%">
                        <v-layout>
                            <v-btn flat icon color="primary" @click="editar(item)">
                                <v-icon>ol-edit</v-icon>
                            </v-btn>
                            <v-btn flat icon color="primary" @click="excluir(item)">
                                <v-icon>ol-delete</v-icon>
                            </v-btn>
                        </v-layout>
                    </td>
                </template>
            </data-table>
        </v-layout>
    </v-container>
</template>

<script>
import DataTable from '../components/DataTable'
import { alert, error, sleep } from '../plugins/helpers'

/**
   * @var item
   * @type {object}
   * @property {number} id_unidade_negocio
   * @property {string} codigo
   * @property {string} nome
   */

export default {
  components: { DataTable },
  data: () => ({
    headers: [
      { text: 'Nome do Perfil', value: 'nome_perfil' },
      { text: 'Usuários Vinculados', value: 'nome_usuario' },
      { value: '', sortable: false }
    ],
    filtro: {
      nome_perfil: '',
      usuarios: ''
    },
    dtFiltro: {},
    popupFiltro: false
  }),
  filters: {
    agg: (items) => items.map((i) => i.nome).join(', ')
  },
  watch: {
    popupFiltro (open) {
      if (open) {
        sleep(100).then(() => this.$refs.textField.focus())
      }
    }
  },
  methods: {
    editar (item) {
      this.$router.push({ name: 'cadastro_perfil', params: { id_perfil_usuario: `${item.id_perfil_usuario}` } })
    },
    excluir (item) {
      alert({
        text: `Tem certeza que deseja excluir o perfil${item.nome_perfil ? ' ' + item.nome_perfil : ''}?`,
        buttons: {
          'Cancelar': () => true,
          'Excluir': () => {
            this.$http.delete(`/admin/perfis/${item.id_perfil_usuario}`, {
              params: {
                id_usuario: this.$session.get('id_usuario')
              }
            })
              .then(() => {
                alert(`Perfil excluído com sucesso!`)
                this.dtFiltro = { ...this.filtro }
              }).catch(err => {
                error(err, 'Não foi possível excluir o perfil.')
              })
          }
        }
      })
    },
    filtrar () {
      this.popupFiltro = false
      this.dtFiltro = { ...this.filtro }
    },
    limpar () {
      this.filtro = {}
      this.filtrar()
    }
  }
}
</script>

<style scoped>
    .text-truncate {
        max-width: 300px;
    }
</style>
